/* globals angular, $ */
(function() {
  'use strict';

  function ReceiverParserCtrl ($filter, $mdPanel, localStorageService) {
    var ctrl = this;
    ctrl._mdPanel = $mdPanel;
    ctrl.$onInit = function () {
      if (!ctrl.receiver && !ctrl.receiver.endereco && !ctrl.receiver.address) return;
      ctrl.addressFormatted = $filter('parseAddressReceiver')(ctrl.receiver.endereco || ctrl.receiver.address);
      ctrl.addressFormatted = $filter('truncate')(ctrl.addressFormatted, false, 42, '…');

      if (!ctrl.receiver.documento) {
        ctrl.receiver.documento = ctrl.receiver.cpf || ctrl.receiver.cnpj;
      }
    };
    ctrl.displayDoc = function (doc) {
      return $filter('document')(doc);
    };
    function _trackEvents (config) {
    }

    ctrl.showPanel = function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var position = ctrl._mdPanel
        .newPanelPosition()
        .relativeTo(evt.currentTarget)
        .addPanelPosition(
          ctrl._mdPanel.xPosition.ALIGN_START,
          ctrl._mdPanel.yPosition.ALIGN_TOPS
        );
      var config = {
        controller: 'ReceiverPanelCtrl',
        controllerAs: '$ctrl',
        template: require('./receiver-panel/receiver-panel.html'),
        panelClass: 'detail-panel font-verlag',
        position: position,
        trapFocus: true,
        zIndex: 150,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          'receiver': ctrl.receiver,
          'tracking': ctrl.tracking,
        },
        onCloseSuccess: function () {
          $elem.removeClass('bg-softgrey');
        },
      };
      ctrl._mdPanel
        .open(config)
        .then(function(){
          _trackEvents({
            type: 'issues',
            email: localStorageService.get('user').email,
            trackId: ctrl.tracking.codigoMandae || ctrl.tracking,
            action: 'click',
            actionName: 'viewCustomer',
          });
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReceiverParserCtrl', ReceiverParserCtrl);
}());
